function EscapeFolderName(current) {
  return current.replace(/\//g, '-')
}
function NewFolderName(current, items = [], options = { name: '____' }) {
  let { name } = options

  current = current ? current + `/${name}` : name
  let pathCountMatch = items.filter(i => i.path.includes(current)).length
  return current + (!pathCountMatch ? '' : `(${pathCountMatch})`)
}

function EscapeRegex(string) {
  return string.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')
}

function ExtractString(str, pattern, options = {}) {
  let { group = 1 } = options
  let match = str.match(pattern)
  if (!match) return
  return match[group]
}

export { EscapeFolderName, NewFolderName, EscapeRegex, ExtractString }
